import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'

export type FeatureFlagSource = 'session' | 'shop' | 'default'

export type FeatureFlagOption = {
  value: string
  active: boolean
  url: string
}

export type FeatureFlag = {
  name: string
  description: string
  source: FeatureFlagSource
  options: FeatureFlagOption[]
  reset_url: string
}

export type FeatureFlagPreview = {
  revealed: string[]
  wildcard: boolean
  options: FeatureFlagOption[]
  reset_url: string
}

export type FeatureFlagsPayload = {
  page: string
  reset_url: string
  flags: FeatureFlag[]
  preview: FeatureFlagPreview
}

const validate = createValidate<FeatureFlagsPayload>()

export const parseFeatureFlags = (data: unknown): FeatureFlagsPayload => {
  validateGuard(validate, data, 'feature flags')
  return data
}
